import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class Mensagem extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loaded: false,
			fiscais: [],
			ficha: {
				usuario: localStorage.nome,
				fiscal: '',
				texto: ''
			}
		}
	}

	componentDidMount() {
		const url = '/api/user/getFiscais'
		axios(url)
			.then(resp => {
				this.setState({ fiscais: [...resp.data] })
			})
			.catch(error => {
				alert(error.response.data)
			}
			)
		const url2 = '/api/auth/checkAuth'
		axios(url2)
			.then(resp => {
				this.setState({ loaded: true })
			})
			.catch(error => {
				alert(error.response.data)
			}
			)
	}

	updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
		console.log(this.state.ficha)
    }

	save(e) {
        const ficha = this.state.ficha
        const url = '/api/mensagem/'
        axios.post(url, ficha)
            .then(resp => {
                alert(resp.data)
				window.location = '/'
            })
            .catch(error => {
                alert(error)
            })
    }

	render() {
		if (this.state.loaded) {
			if (localStorage.tipo == "coordenacao" || localStorage.tipo == "presidencia" ||
				localStorage.tipo == "vice-presidencia" || localStorage.tipo == "interno" ||
				localStorage.tipo == "defis") {
				return (
					<React.Fragment>
						<div className="container mx-auto">
							<div className="form-group row text-left">
								<label className="col-3 col-md-2 mt-3">Usuário:</label>
								<div className="col-9 col-md-4 mb-3 mt-3">
									<input type="text" className="form-control" value={this.state.ficha.usuario} />
								</div>
								<label className="col-3 col-md-2 mt-3">Fiscal:</label>
								<div className="col-9 col-md-4 mb-3 mt-3">
									<select className="custom-select"
										name="fiscal"
										onChange={e => this.updateField(e)} >
										<option value=""></option>
										{this.renderFiscais()}
									</select>
								</div>
								<label className="col-12">Texto:</label>
								<textarea type="textarea" rows="8" className="form-control col-12 mb-5"
									name="texto" onChange={e => this.updateField(e)} />
								<Button onClick={e => this.save(e)} disabled={this.state.button} />
							</div>
						</div>
					</React.Fragment>
				)
			} else {
				return window.location = '/'
			}
		} else {
			return <div></div>
		}
	}

	renderFiscais() {
		let select = []
		this.state.fiscais.map(ficha => {
			select.push(<option value={ficha.nome}>{ficha.nome}</option>)
		})
		return select
	}
}